import { hasPermission } from "../../Config/permissions.js";

const AS_USER_TYPES = new Set(["Admin", "ASD", "Authorizer", "Viewer"]);

export const canEditIvrProduct = (user) =>
  Boolean(
    user &&
      AS_USER_TYPES.has(user.Type) &&
      hasPermission(user, "ivr_product.edit"),
  );

export const canDeleteIvrProduct = (user) =>
  Boolean(
    user &&
      AS_USER_TYPES.has(user.Type) &&
      hasPermission(user, "ivr_product.delete"),
  );
